
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.accordion-button.inactive,
.accordion-button.active,
.accordion-button.clean,
.accordion-button.clean.active,
.accordion-icon.active,
.accordion-icon.inactive,
.accordion-icon.clean.inactive{
  background-color: var(--neutral-transparent) !important;
}

.facet-panel {
  margin-bottom: 0px;
  border-width: 0px;
  padding: 0px;
}

.facet-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  width: 100%;
  padding-bottom: 0.75rem;
  padding-left: 0px;
  cursor: pointer;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--blue-responsible-darken-2);
  border-bottom:1px solid var(--blue-responsible-main);
}

.accordion-button.facet-button.mobile,
.facet-button.mobile{
  padding-left: 0px !important;
  padding-bottom: 0.75rem !important;
}

.facet-button:hover .facet-label, .facet-button:focus .facet-label {
  cursor: pointer;
  color: var(--blue-responsible-main);
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.facet-label {
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--blue-responsible-darken-2);
}

.facet-icon {
  height: auto;
  width: auto;
}

.facet-icon.active, .facet-icon.inactive {
  color: var(--blue-responsible-darken-2);
}

idb-icon.active {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.facet-content {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  padding-bottom: 1.5rem;
}
`;